import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function British() {
  return (
    <ApiCommunityDirectoryPage
      community="British"
      eyebrow="British community guide"
      title="British favorites, businesses, and local essentials in San Antonio."
      
      tags={["British community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the British community guide?"
      modalIdPrefix="british-directory"
    />
  );
}
